import "../css/style.scss";
//  alert("Just a tester");
//  console.log("from index.js");
//  document.addEventListener("DOMContentLoaded", function() {
//   document.getElementById("demo").textContent = "Hello!";
// });

// const element = document.getElementById("myBtn");
// element.addEventListener("click", myFunction);

// function myFunction() {
//   document.getElementById("demo").innerHTML = "Hello World";
// }

//document.getElementById("jeteste").style.color = "red";
// Our modules / classes
import MobileMenu from "./modules/MobileMenu";
import HeroSlider from "./modules/HeroSlider";
import Like from "./modules/like";

// Instantiate a new object using our modules/classes
const mobileMenu = new MobileMenu();
const heroSlider = new HeroSlider();
const like = new Like();

// document.getElementById("demo").innerHTML = "Hello World in here";




// document.getElementById("demo").innerHTML = "Hello World in here";
